import React, { FC } from 'react'
import Typography from '../../../../global/typography'
import { HeaderTags, PartnersLocatorTiers, PartnersLocatorTiersOuter } from '../../partnerListings'

type Props = {
  platinumTitleText: string
  platinumBodyText: string
  diamondTitleText: string
  diamondBodyText: string
  goldTitleText: string
  goldBodyText: string
  authorizedTitleText: string
  authorizedBodyText: string
  certifiedTitleText: string
  certifiedBodyText: string
  awardTitleText: string
  awardBodyText: string
}

const BadgeDetails: FC<Props> = ({
  platinumTitleText,
  platinumBodyText,
  diamondTitleText,
  diamondBodyText,
  goldTitleText,
  goldBodyText,
  authorizedTitleText,
  authorizedBodyText,
  certifiedTitleText,
  certifiedBodyText,
  awardTitleText,
  awardBodyText,
}) => {
  return (
    <PartnersLocatorTiersOuter>
      <PartnersLocatorTiers>
        <div className="PartnersLocator__Tier-Container">
          <HeaderTags $level="Diamond">{diamondTitleText}</HeaderTags>
          <Typography type="bodyXS" className="font__inter">
            {diamondBodyText}
          </Typography>
        </div>

        <div className="PartnersLocator__Tier-Container">
          <HeaderTags $level="Platinum">{platinumTitleText}</HeaderTags>
          <Typography type="bodyXS" className="font__inter">
            {platinumBodyText}
          </Typography>
        </div>

        <div className="PartnersLocator__Tier-Container">
          <HeaderTags $level="Gold">{goldTitleText}</HeaderTags>
          <Typography type="bodyXS" className="font__inter">
            {goldBodyText}
          </Typography>
        </div>

        <div className="PartnersLocator__Tier-Container">
          <HeaderTags $level="Authorized">{authorizedTitleText}</HeaderTags>
          <Typography type="bodyXS" className="font__inter">
            {authorizedBodyText}
          </Typography>
        </div>

        <div className="PartnersLocator__Tier-Container">
          <HeaderTags $level="Certified">{certifiedTitleText}</HeaderTags>
          <Typography type="bodyXS" className="font__inter">
            {certifiedBodyText}
          </Typography>
        </div>

        <div className="PartnersLocator__Tier-Container">
          <HeaderTags $level="Award">{awardTitleText}</HeaderTags>
          <Typography type="bodyXS" className="font__inter">
            {awardBodyText}
          </Typography>
        </div>
      </PartnersLocatorTiers>
    </PartnersLocatorTiersOuter>
  )
}

export default BadgeDetails
